import { actions } from "@/constants/state";
import store from "@/store";

export default async (to, from, next) => {
  try {
    await store.dispatch(actions.AGENDAS_FETCH_ACTION);
  } catch (error) {
    console.error(actions.AGENDAS_FETCH_ACTION, error);
  }

  next();
};
